import React from "react"
import { injectIntl} from "gatsby-plugin-intl"
import './footer.scss'
import "./header.scss"
import facebookimg from '../images/facebook.svg'
import linkedinimg from '../images/linkedin.svg'
import instagramimg from '../images/instagram.svg'

const Footer = ( { intl, pathname } ) => {
  let [ lang, page ] = pathname.substr( 1 ).split( '/' )

  if( lang === '.alpha' ) {
    lang = page
  }

  const socialmedia = page !== 'contact'
        ?<div className="socialMidia" style={{display: 'flex'}}>
          <li><a href="https://www.facebook.com/TryConsultoria" target="_blank" rel="noopener noreferrer"><img src={facebookimg} style={{width: '20px', height: '20px'}} alt="Facebook"/></a></li>
          <li><a href="https://www.linkedin.com/company/try-consultoria-e-pesquisas" target="_blank" rel="noopener noreferrer"><img src={linkedinimg} style={{width: '20px', height: '20px'}} alt="LinkedIn" /></a></li>
          <li><a href="https://instagram.com/try.consultoria/" target="_blank" rel="noopener noreferrer"><img src={instagramimg} style={{width: '20px', height: '20px'}} alt="Instagram" /></a></li>
          </div>
          : null

  const contactFooter = page === 'contact'
        ?<div className="socialMidiaContact" >
          <label>© Try 2003-{ (new Date()).getFullYear() }</label>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
            <label style={{marginRight: '20px'}}>{ intl.formatMessage( { id: "contact.uxfellows" } ) }</label>
            <img src={require('../images/uxfellowsContact.png')} alt="UXFellowsContact" style={{width: '120px'}} />
          </div>
        </div>
        : null

  const hirelink = lang === 'pt'
        ? <a href="https://tryusabilidade.typeform.com/to/K2hOHP" target="_blank" rel="noopener noreferrer"> { intl.formatMessage( { id: "nav-link.hiring" } ) } </a>
        : <a href="/research" target="_blank" rel="noopener noreferrer"> Need a research project? { intl.formatMessage( { id: "nav-link.hiring" } ) } </a>

  return (
   <footer className="footer">
    <ul className="footer links">
    <li><strong>{ intl.formatMessage( { id: "contact.title" } ) }</strong><br/></li>
     <li>{ intl.formatMessage( { id: "contact.email" } ) }</li>
    <li >+55 11 3071 3810</li>
    </ul>
    <ul className="footer links ">
      <li ><strong>{ intl.formatMessage( { id: "contact.address.title" } ) }</strong><br/></li>
      <li>{ intl.formatMessage( { id: "contact.address.street" } ) }</li>
      <li >{ intl.formatMessage( { id: "contact.address.city" } ) }</li>
      <li >{ intl.formatMessage( { id: "contact.address.zip" } ) }</li>
    </ul>
     <ul className="footer links ">
      <li ><strong>{ intl.formatMessage( { id: "contact.uxfellows" } ) }</strong><br/></li>
      <li><a href="https://www.uxfellows.com/" target="_blank" rel="noopener noreferrer"><img src={require('../images/uxfellows.png')} style={{width: '120px'}} alt="UXFellows" /></a></li>
    </ul>
     <ul className="footer links">
       <li className="hiring "><strong>{ hirelink }</strong></li>
      </ul>
      <div className="footer-break" ></div>
      {contactFooter}
        {page !== 'contact' ?
        <ul className="footer social-media ul" >
        <li style={{textAlign: 'left'}} className="copyright">© Try 2003-{ (new Date()).getFullYear() }</li>
        {socialmedia} 
      </ul> : null }
   </footer>
  )
}

export default injectIntl( Footer );
